import { h, Fragment } from 'preact';

import I18n from '../../lib/I18n';
import RightArrow from '../../molecules/Icon/RightArrow';
import './index.less';

export default ({ updateStep, onNoCoupon }) => {
  const dialogOptions = [
    {
      title: 'I_WANT_TEN_PERCENT_OFF',
      className: 'required',
      fill: '#148D32',
      onClick: () => updateStep('1')
    },
    {
      title: 'I_DONT_WANT_TEN_PERCENT_OFF',
      className: 'not-required',
      fill: '#DA253A',
      onClick: onNoCoupon
    }
  ];

  return (
    <Fragment>
      <div className="offer-title">{I18n.t('TEN_PERCENT_OFF')}</div>
      <div className="coupon-subtitle">{I18n.t('ARE_YOU_SURE_YOU_DONT_WNAT_TEN_PERCENT_OFF')}</div>
      <div className="confirm-options">
        {dialogOptions.map(({ onClick, className, fill, title }, index) => (
          <div className="confirm-option" key={index} onClick={onClick}>
            <span className={`option-title ${className}`}>{I18n.t(title)}</span>
            <RightArrow height={'30px'} fill={fill} />
          </div>
        ))}
      </div>
    </Fragment>
  );
};
